<script>
    import { LIST_ITEM_SIZE } from '../constants';
    import { onMount } from 'svelte';
	import { images } from '../store';

    let position = 0;
    let maxPosition = 0;

	images.subscribe(list => {
	  if (list.length > 4) {
	    maxPosition = list.length - 4;
	  }
	});

    const gotoPreviousPage = () => position = position - 1;
    const gotoNextPage = () => position = position + 1;
</script>

<div class="list-container">
    {#if position !== 0}
        <button class="arrow arrow-top icon chevron_left" on:click={gotoPreviousPage}></button>
    {/if}
    <div class="paginated-content">
        <div class="content" style={`transform: translateY(${-position * (LIST_ITEM_SIZE + 12)}px)`}>
            <slot />
        </div>
    </div>
    {#if position < maxPosition}
        <button class="arrow arrow-down icon chevron_right" on:click={gotoNextPage}></button>
    {/if}
</div>

<style>
    .list-container {
        position: relative; width: 145px; height: 610px;
    }
    .paginated-content {
        height: 100%; overflow: hidden;
    }
    .content {
        transition: 250ms transform ease-in-out;
    }
    .arrow {
        position: absolute; left: 50%; top: 0%; z-index: 1; padding: 10px; background: none; border: 0;
        font-size: 2em; line-height: 1; text-align: center; cursor: pointer; color: #e67376;
        transform: translate3d(-50%, -100%, 0) rotate(90deg);
    }
    .arrow-down {
        top: 100%;
        transform: translate3d(-50%, 0, 0) rotate(90deg);
    }
</style>
